import App from './App.vue';

export default {
  path: '/CDS_VF_HeliportDetail',
  name: 'CDS_VF_HeliportDetail',
  component: App,
  meta: {
    pageProperty: {
      title: 'ヘリポート詳細',
      controller: 'CDS_CTR_HeliportDetail',
    },
  },
};
